import type { PermissionTuple } from '~/utils/ability'

/**
 * Droits v2 du module Service client, les mêmes que les gardes de l'API (`/service-client/*`).
 * Sans import de composant, pour être lus sous Node par les tests.
 */

/** Écran et détail d'un ticket : liste et fiche (`GET /service-client/tickets*`). */
export const SERVICE_CLIENT_TICKET_READ: PermissionTuple = ['read', 'service-client.tickets.ticket']

/**
 * Traiter les tickets : assigner (et lister les agents), changer la priorité, résoudre ou rouvrir,
 * marquer non lu, fusionner.
 */
export const SERVICE_CLIENT_TICKET_EDIT: PermissionTuple = ['edit', 'service-client.tickets.ticket']
